export default __webpack_public_path__ + "static/media/DAS_SCHNELLE.3ce8987b.png";